import type React from 'react'
import { cn } from '../../../shared/cn'

export function P2({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p
      {...props}
      className={cn('font-normal text-base text-contentPrimary leading-6', className)}
    />
  )
}
